import { render, staticRenderFns } from "./AssignPermissions.vue?vue&type=template&id=7a7c492f&scoped=true"
import script from "./AssignPermissions.vue?vue&type=script&lang=js"
export * from "./AssignPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c492f",
  null
  
)

export default component.exports